export const STATION_ITEM_TYPE = {
    STATION: 1, //站台
    TRACK: 2,   //股道
}

export const STATION_TYPE = {
    STATION_FIRST: 1,   // 站台在前
    TRACK_FIRST: 2,     // 股道在前
}